<template>
    <div id="new-sms-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("whatsappChannel.channelName") }}</label>
                    <a-form-item
                        :validate-status="getErrorStatus('channelName')"
                        :help="getErrorMessage('channelName')"
                    >
                        <a-input
                            v-model="form.channelName"
                            :placeholder="$t('whatsappChannel.channelName')"
                            name="channelName"
                            ref="channelName"
                        />
                    </a-form-item>
                </div>
                <div class="input-wrapper">
                    <label>{{ $t("message.username") }}</label>
                    <a-input
                        :placeholder="$t('message.username')"
                        v-model="form.username"
                        v-validate="'required'"
                        name="username"
                    />
                </div>
                <div class="input-wrapper">
                    <label>{{ $t("message.password") }}</label>
                    <a-input-password
                        :placeholder="$t('message.password')"
                        v-model="form.password"
                        v-validate="'required'"
                        name="password"
                    />
                </div>
                <div class="input-wrapper">
                    <label>{{ $t("message.defaultSender") }}</label>
                    <a-input
                        placeholder="SUPSIS"
                        v-model="form.defaultSender"
                        name="defaultSender"
                    />
                    <span class="hint">{{ $t("message.netgsmSenderHint") }}</span>
                </div>
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">{{ $t("message.cancel") }}</a-button>
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                    {{ $t("message.save") }}</a-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import _ from "lodash";

export default {
    name: "NewNetgsmChannel",
    props: {
        channel: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            form: {
                channelName: "",
                username: "",
                password: "",
                defaultSender: "",
                forward: {
                    department: null,
                    story: null,
                    mode: "live",
                    hybrid: {
                        department: null,
                    },
                },
            },
            loading: false,
            clone: _.cloneDeep(this.channel),
            submitClicked: false,
        };
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        getErrorStatus(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? this.$t("message.requiredChannel") : "";
        },
        handleCancel() {
            this.$emit("cancel");
        },
        handleSave() {
            this.submitClicked = true;
            if (this.form.channelName.length < 1) {
                this.$refs.channelName.focus();
                return;
            }
            const payload = {
                type: "sms-netgsm",
                name: this.form.channelName,
                payload: {
                    username: this.form.username,
                    password: this.form.password,
                    defaultSender: this.form.defaultSender,
                },
                forward: this.form.forward,
            };
            this.loading = true;
            this.createChannel(payload)
                .then(() => {
                    this.$message.success(this.$t("message.channelCreatedSuccessfully"));
                    this.$emit("ok");
                })
                .catch(() => {
                    this.$message.error(this.$t("message.failedToCreateChannel"));
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#new-sms-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;

            .hint {
                font-size: 12px;
                color: var(--color-text-low-default);
            }
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style>

<style lang="scss">
.new-sms-netgsm {
    .custom-modal-body {
        padding: 0px !important;
    }
}
</style>
